import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import ErrorPanel from "../../components/ErrorPanel";

import { Dialog } from "../../hooks/useDialog";

import Portfolio from "./Portfolio";

import { getUser } from "helpers/userStorage";

import Button from "@material-ui/core/Button";
import { hashHistory } from "browserHistory";

const PortfolioItem = (props) => {
  const { portfolio } = props;
  const { instances } = portfolio;

  const [expandOthers, expandOthers_set] = React.useState(false);

  var user = getUser();

  return (
    <div>
      <div style={{ border: "1px solid #dddddd", marginBottom: 10 }}>
        <div
          style={{
            display: "flex",
            whiteSpace: "nowrap",
            backgroundColor: "#f6f6f6",
            borderBottom: "1px solid #dddddd",
          }}
        >
          <div style={{ margin: 10, width: "100%" }}>
            Portfolio: {portfolio.name}
          </div>
        </div>
        {instances.length > 0 && (
          <div>
            {instances.map((e, i) => (
              <div key={`p_${e.id}`}>
                {i === 0 && (
                  <div style={{}}>
                    <Portfolio
                      {...props}
                      portfolio={e}
                      isFirst={true}
                      isAdmin={user && user.isAdmin}
                    />

                    {instances.length > 1 && (
                      <div style={{ margin: 20 }}>
                        <Button
                          variant={"outlined"}
                          color={"primary"}
                          onClick={() => {
                            expandOthers_set(!expandOthers);
                          }}
                        >
                          {expandOthers ? "Hide past orders" : `View more`}
                        </Button>
                      </div>
                    )}
                  </div>
                )}
                {i > 0 && expandOthers && (
                  <div style={{ borderTop: "1px solid #dddddd" }}>
                    <Portfolio
                      {...props}
                      portfolio={e}
                      isAdmin={user && user.isAdmin}
                    />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

const Main = (props) => {
  const { editorState, account, actions } = props;

  React.useEffect(() => {
    actions.loadPortfolios();

    const update = (ev) => {
      if (ev.key === "portfolioDeleted" && ev.newValue === "true") {
        if (!account.loading) {
          actions.loadPortfolios();
        }
      }
    };

    window.addEventListener("storage", update);

    return () => {
      window.removeEventListener("storage", update);
    };
  }, []);

  const { portfolios = [] } = account.portfolios;

  return (
    <div>
      {(account.loading || account.portfolioDeleting) && (
        <div style={{ textAlign: "center", margin: 60 }}>
          <div>
            <CircularProgress />
          </div>
          <div>Loading...</div>
        </div>
      )}
      {editorState.copying && (
        <div>
          <Dialog maxWidth="sm" fullWidth="true" actionButtons={[]}>
            <div style={{ textAlign: "center", margin: 60 }}>
              <div>
                <CircularProgress />
              </div>
              <div>Copying...</div>
            </div>
          </Dialog>
        </div>
      )}
      {account.error && (
        <div>
          <ErrorPanel error={account.error} />
        </div>
      )}
      {!account.portfolioDeleting && !account.loading && !account.error && (
        <div>
          <div style={{ marginBottom: 10, textAlign: "right" }}>
            <Button
              variant={"contained"}
              color={"primary"}
              onClick={() => {
                hashHistory.push("/DataEntry");
              }}
            >
              Create A New Portfolio
            </Button>
          </div>
          {portfolios.length === 0 && <div>You have no portfolios.</div>}
          {portfolios.length > 0 && (
            <div>
              {portfolios.map((e) => (
                <PortfolioItem {...props} portfolio={e} key={`p_${e.name}`} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Main;



// WEBPACK FOOTER //
// ./src/account/components/MyPortfolios.js